/**
 * Cheat - provides cheat menu functionality and variable/property freezing
 */

import { $dom, ready } from './DOM';

// Forward declarations
declare function SetVariable(tempvar: any, bArraySet: boolean, bJavascript: boolean, varindex: any, varindex1a: any, replacedstring: string, cmdtxt: string, part3: string): Promise<void>;
declare function SetCustomProperty(curprop: any, part3: string, replacedstring: string, entityId: string): void;
declare namespace ReactDOM {
    function render(element: any, container: HTMLElement): void;
}
declare const CheatMenuContent: any;

export const cheatFreezes = {
    variables: {} as { [key: string]: boolean },
    playerProperties: {} as { [key: string]: boolean },
    customProperties: {} as { [entityId: string]: { [propertyName: string]: boolean } }
};

// Store React root to reuse it
let cheatMenuRoot: any = null;

function isFrozenVariable(variable: any): boolean {
    return !!cheatFreezes.variables[variable.varname];
}

function isFrozenPlayerProperty(property: any): boolean {
    return !!cheatFreezes.playerProperties[property.Name];
}

ready(() => {
    $dom("#cheat_button").click((e) => {
        // Don't allow cheat menu when input is requested
        if ((window as any).gameController?.gameAwaitingInput) return;
        
        const dialogRoot = document.getElementById('cheat-dialog-root');
        if (dialogRoot && (window as any).React && (window as any).ReactDOM) {
            const React = (window as any).React;
            const ReactDOM = (window as any).ReactDOM;
            const CheatMenuContent = (window as any).CheatMenuContent;
            
            if (CheatMenuContent) {
                if (ReactDOM.createRoot) {
                    // React 18: reuse root if it exists, otherwise create it
                    // Always recreate the root to ensure it can reopen
                    if (cheatMenuRoot) {
                        // Unmount existing root
                        cheatMenuRoot.render(null);
                    }
                    cheatMenuRoot = ReactDOM.createRoot(dialogRoot);
                    (window as any).cheatMenuRoot = cheatMenuRoot;
                    cheatMenuRoot.render(React.createElement(CheatMenuContent));
                } else {
                    // Fallback for older React versions
                    ReactDOM.render(
                        React.createElement(CheatMenuContent),
                        dialogRoot
                    );
                }
            } else {
                console.warn('CheatMenuContent component not found');
            }
        }
    });

    const originalSetVariable = (window as any).SetVariable;
    if (originalSetVariable) {
        (window as any).SetVariable = async function (tempvar: any, bArraySet: boolean, bJavascript: boolean, varindex: any, varindex1a: any, replacedstring: string, cmdtxt: string, part3: string): Promise<void> {
            if (isFrozenVariable(tempvar)) {
                return;
            }
            return originalSetVariable.apply(this, arguments);
        };
    }

    const originalSetCustomProperty = (window as any).SetCustomProperty;
    if (originalSetCustomProperty) {
        (window as any).SetCustomProperty = function (curprop: any, part3: string, replacedstring: string, entityId: string): void {
            if (entityId === 'player' && isFrozenPlayerProperty(curprop)) {
                return;
            }
            return originalSetCustomProperty.apply(this, arguments);
        };
    }
});

// Make available globally
(window as any).cheatFreezes = cheatFreezes;
